export default function isEchoLineId(lineId) {
  return typeof lineId === 'string';
}
